"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const google_1 = require("./google");
const base_1 = require("./base");
(() => {
    (0, google_1.generateGoogleLinks)();
    (0, base_1.updateUTCToUserTZ)();
})();
